<template>
    <el-dialog
            :visible="isVisible"
            @close="hide"
            :title="title"
            :destroy-on-close="true"
    >
        <loading v-if="!isInitialized"></loading>
        <campaign-template-form
                v-if="isInitialized"
                v-bind="formData"
                @stored="onStored"
        ></campaign-template-form>
    </el-dialog>
</template>

<script>
  import BaseDialogFormWrapper from '../../components/dialog-form-wrapper';
  import CampaignTemplateForm from '../../components/campaign-template/form';
  import Loading from '../../components/loading';
  import eventBus from '../../event-bus';

  export default {
    extends: BaseDialogFormWrapper,

    components: {
      Loading,
      CampaignTemplateForm
    },

    computed: {
      /**
       * @return {string}
       */
      title() {
        if (!this.isInitialized) {
          return 'Loading ...';
        } else if (_.get(this.formData, 'model.id')) {
          return 'Edit Campaign Template'
        }

        return 'Create Campaign Template'
      },
    },
    methods: {
      /**
       * @param {string|undefined} message
       */
      onStored({message}) {
        _.isString(message) && this.$message.success(message);
        this.hide();
        eventBus.$emit('refresh-campaign-template-table');
      },
    },

    created() {
      eventBus.$on('show-add-campaign-template-dialog', this.show);
    },

    beforeDestroy() {
      eventBus.$off('show-add-campaign-template-dialog', this.show);
    }
  }
</script>
